// CancelCaseModal.jsx
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

const CancelCaseModal = ({ show, handleClose, handleConfirm, caseNumber }) => {
  const [reason, setReason] = useState("");

  const onConfirm = () => {
    handleConfirm(reason);
    setReason(""); // Reset reason after confirming
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cancel Case #{caseNumber}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="cancellationReason">
            <Form.Label>Reason for Cancellation (Optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter reason for cancellation..."
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={caseNumber === undefined}
        >
          Confirm Cancellation
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelCaseModal;